/* Villain Magazine — on phones, card rows become side-scrolling rails with a counter and progress line;
   each rail advances on its own every few seconds while in view, until the reader touches it. */
(function () {
  const phone = window.matchMedia('(max-width: 760px)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const rails = Array.from(document.querySelectorAll('.archive-grid, .merch-grid, .partners, .events, .tenets'));

  rails.forEach((rail) => {
    const items = Array.from(rail.children);
    if (items.length < 2) return;
    const total = String(items.length).padStart(2, '0');
    const ui = document.createElement('div');
    ui.className = 'rail-ui label';
    ui.innerHTML = '<span><b>01</b> / ' + total + '</span><span class="rail-bar"><i></i></span><span>Swipe</span>';
    rail.after(ui);
    const count = ui.querySelector('b');
    const bar = ui.querySelector('i');

    const current = () => {
      const x = rail.scrollLeft + items[0].offsetLeft;
      let best = 0;
      items.forEach((it, k) => { if (Math.abs(it.offsetLeft - x) < Math.abs(items[best].offsetLeft - x)) best = k; });
      return best;
    };
    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      bar.style.transform = 'scaleX(' + (max > 0 ? 0.15 + 0.85 * (rail.scrollLeft / max) : 1) + ')';
      count.textContent = String(current() + 1).padStart(2, '0');
    };
    rail.addEventListener('scroll', update, { passive: true });
    update();

    if (reduce) return;
    let touched = false;
    let visible = false;
    ['touchstart', 'pointerdown', 'wheel'].forEach((ev) => rail.addEventListener(ev, () => { touched = true; }, { passive: true }));
    new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }, { threshold: 0.5 }).observe(rail);

    setInterval(() => {
      if (touched || !visible || !phone.matches || document.hidden) return;
      const max = rail.scrollWidth - rail.clientWidth;
      if (max <= 0) return;
      const next = items[current() + 1];
      const left = !next || rail.scrollLeft >= max - 4 ? 0 : next.offsetLeft - items[0].offsetLeft;
      rail.scrollTo({ left, behavior: 'smooth' });
    }, 3600);
  });
})();
